import InteractiveGridElement from "components/WarehouseElements/Grid/InteractiveGridElement/InteractiveGridElement";
import { WarehouseElementLocation } from "components/WarehouseElements/WarehouseElementsData";
import { JSX } from "react";

export type BorderOverrideProps = {
  removeTopBorder: boolean;
  removeBottomBorder: boolean;
  removeLeftBorder: boolean;
  removeRightBorder: boolean;
};

export function createAdjacentBorders(
  gridElementLocationSpan: WarehouseElementLocation[],
  id: string,
  gridElementType: string,
  mainGridLocation: WarehouseElementLocation
): JSX.Element[] {
  const normalizedSpans = gridElementLocationSpan.map(span => ({
    ...span,
    end: span.end ?? span.start,
  }));

  const xPoints = new Set<number>();
  const yPoints = new Set<number>();
  normalizedSpans.forEach(span => {
    xPoints.add(span.start.x);
    xPoints.add(span.end.x + 1);
    yPoints.add(span.start.y);
    yPoints.add(span.end.y + 1);
  });
  const sortedX = Array.from(xPoints).sort((a, b) => a - b);
  const sortedY = Array.from(yPoints).sort((a, b) => a - b);

  const atomicGrid: boolean[][] = Array(sortedY.length - 1)
    .fill(false)
    .map(() => Array(sortedX.length - 1).fill(false));
  const xMap = new Map(sortedX.map((x, i) => [x, i]));
  const yMap = new Map(sortedY.map((y, i) => [y, i]));

  normalizedSpans.forEach(span => {
    const xStartIdx = xMap.get(span.start.x)!;
    const xEndIdx = xMap.get(span.end.x + 1)!;
    const yStartIdx = yMap.get(span.start.y)!;
    const yEndIdx = yMap.get(span.end.y + 1)!;
    for (let y = yStartIdx; y < yEndIdx; y++) {
      for (let x = xStartIdx; x < xEndIdx; x++) {
        atomicGrid[y][x] = true;
      }
    }
  });

  const cellsToRender: JSX.Element[] = [];
  for (let yIdx = 0; yIdx < atomicGrid.length; yIdx++) {
    for (let xIdx = 0; xIdx < atomicGrid[yIdx].length; xIdx++) {
      if (!atomicGrid[yIdx][xIdx]) continue;

      const borderOverrides: BorderOverrideProps = {
        removeTopBorder: yIdx > 0 && atomicGrid[yIdx - 1][xIdx],
        removeBottomBorder:
          yIdx < atomicGrid.length - 1 && atomicGrid[yIdx + 1][xIdx],
        removeLeftBorder: xIdx > 0 && atomicGrid[yIdx][xIdx - 1],
        removeRightBorder:
          xIdx < atomicGrid[yIdx].length - 1 && atomicGrid[yIdx][xIdx + 1],
      };

      const cellSpan: WarehouseElementLocation = {
        start: { x: sortedX[xIdx], y: sortedY[yIdx] },
        end: { x: sortedX[xIdx + 1] - 1, y: sortedY[yIdx + 1] - 1 },
      };

      cellsToRender.push(
        /* eslint-disable */
        <InteractiveGridElement
          key={`${id}-${cellSpan.start.x}-${cellSpan.start.y}`}
          id={id}
          type={gridElementType}
          gridElementLocationSpan={cellSpan}
          borderOverrides={borderOverrides}
          mainGridLocation={mainGridLocation}
        />
      );
    }
  }
  return cellsToRender;
}
